import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import s from './InputFieldOutline.scss';
/** The outline and background for our input fields.  */
var InputFieldOutline = function (_a) {
    var outlineStyle = _a.outlineStyle, className = _a.className, children = _a.children, rest = __rest(_a, ["outlineStyle", "className", "children"]);
    return (React.createElement("div", __assign({ className: c(s['root'], outlineStyle === 'success' && s['success'], outlineStyle === 'error' && s['error'], outlineStyle === 'disabled' && s['disabled'], className) }, rest), children));
};
InputFieldOutline.displayName = 'InputFieldOutline';
export default InputFieldOutline;
//# sourceMappingURL=InputFieldOutline.js.map